import { render, staticRenderFns } from "./activitySignup.vue?vue&type=template&id=631bbdd3&scoped=true&"
import script from "./activitySignup.vue?vue&type=script&lang=js&"
export * from "./activitySignup.vue?vue&type=script&lang=js&"
import style0 from "./activitySignup.vue?vue&type=style&index=0&id=631bbdd3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bbdd3",
  null
  
)

export default component.exports